export const initialMainRoute = "dashboard";

export const crudRoutes = {
  create: "creaza",
  edit: "edit",
};

export const externalRouter = {
  translogTracking: "https://admin.aheadtranslog.ro/public/awb-tracking",
};

export const generalRoutes = {
  createAwb: "creeaza-awb",
  createBin: "creeaza-bin",
};

export const expeditionRoutes = {
  routes: "rute",
  nodes: "noduri",
  workingPoints: "puncte-de-lucru",
  clientWorkingPoints: "puncte-de-lucru-client",
  organize: "organizeaza",
  undeliveredAwb: "comenzi-nefinalizate",
  undeliveredBins: "binuri-nefinalizate",
  deliveredAwbHistory: "istoric-colete-livrate",
  deliverySheets: "borderouri",
};
